// extracted by mini-css-extract-plugin
module.exports = {"sectionHeader":"SectionHeader_sectionHeader__H9Nzu","sectionSecondaryHeader":"SectionHeader_sectionSecondaryHeader__rHGLq","sectionRoot":"SectionHeader_sectionRoot__3qf48"};